var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('div',{staticClass:"container-xs"},[_c('div',{staticClass:"md"},[(_vm.articleContent)?_c('VueShowdown',{attrs:{"markdown":_vm.articleContent}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }